
export const isNativeApp = (): boolean => {
    // Detects if running in a wrapper like Capacitor or Bubblewrap
    const isCapacitor = (window as any).Capacitor !== undefined;
    // Detects if running as an installed PWA (Standalone mode)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone === true;
    
    return isCapacitor || isStandalone;
};

export const isIOS = (): boolean => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
};
